import api from './api';

const userService = {
  // Get current user profile
  async getProfile() {
    try {
      const response = await api.get('/users/profile');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Create a new user (Admin only)
  async createUser(userData) {
    try {
      // Re-using the auth register endpoint, or a specific admin endpoint if available
      // Assuming /auth/register is open, but for admin actions we might want a specific one
      // If the backend expects an admin-specific creation route:
      // const response = await api.post('/users', userData);

      // For now, attempting to use the public register which returns token/user
      // But usually admins want to create user without logging in as them.
      // Let's assume there is a POST /users endpoint for admins based on standard REST patterns for the dashboard
      const response = await api.post('/users', userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Update current user profile
  async updateProfile(data) {
    try {
      const response = await api.patch('/users/profile', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get all users (Admin only)
  async getAllUsers() {
    try {
      const response = await api.get('/users');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get user by ID (Admin only)
  async getUserById(id) {
    try {
      const response = await api.get(`/users/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Update user by ID (Admin only)
  async updateUser(id, data) {
    try {
      const response = await api.patch(`/users/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Delete user (Admin only)
  async deleteUser(id) {
    try {
      const response = await api.delete(`/users/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default userService;
